import { FIELD_KEYS } from "./constants";

let rowIdCounter = 0;

export function createRowId() {
  rowIdCounter += 1;
  return `bulk-row-${Date.now()}-${rowIdCounter}`;
}

export function emptyFieldMeta() {
  return { fieldStatus: {}, fieldMessages: {} };
}

export function createEmptyRow(seq = 1, overrides = {}) {
  return {
    id: createRowId(),
    seq,
    sido: "",
    fireStation: "",
    safetyCenter: "",
    eqp: "",
    callsgn: "",
    plateNo: "",
    sumnum: "",
    name: "",
    pnum: "",
    rdvs: "",
    cntct: "",
    remark: "",
    fieldStatus: {},
    fieldMessages: {},
    rowStatus: "pending",
    saveStatus: "idle",
    ...overrides,
  };
}

export function reindexRows(rows) {
  return rows.map((row, i) => ({ ...row, seq: i + 1 }));
}

export function rowFromExcelArray(arr, seq) {
  const v = (i) => (arr[i] != null ? String(arr[i]).trim() : "");
  return createEmptyRow(seq, {
    sido: v(1),
    fireStation: v(2),
    safetyCenter: v(3),
    eqp: v(4),
    callsgn: v(5),
    plateNo: v(6),
    sumnum: v(7),
    name: v(8),
    pnum: v(9),
    rdvs: v(10),
    cntct: v(11),
    remark: v(12),
  });
}

export function rowToExcelArray(row) {
  return [
    row.seq,
    row.sido,
    row.fireStation,
    row.safetyCenter,
    row.eqp,
    row.callsgn,
    row.plateNo,
    row.sumnum,
    row.name,
    row.pnum,
    row.rdvs,
    row.cntct,
    row.remark,
  ];
}

export function updateRowField(row, fieldKey, value) {
  if (!FIELD_KEYS.includes(fieldKey)) return row;
  const fieldStatus = { ...(row.fieldStatus || {}) };
  const fieldMessages = { ...(row.fieldMessages || {}) };
  delete fieldStatus[fieldKey];
  delete fieldMessages[fieldKey];
  return {
    ...row,
    [fieldKey]: value,
    fieldStatus,
    fieldMessages,
    rowStatus: "pending",
    saveStatus: row.saveStatus === "saved" ? "idle" : row.saveStatus,
  };
}

export function fmtPhone(value) {
  const d = String(value || "")
    .replace(/\D/g, "")
    .slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}

/** 선탑전화번호 — 실번호 여부 무관, 000-0000-0000 형식(3-4-4)만 검사 */
export function isValidPnumFormat(value) {
  return /^\d{3}-\d{4}-\d{4}$/.test(String(value ?? "").trim());
}
